<div class="default-padding">
  <div class="centered-container flex-container logsign phone-verify">
    <div class="logsign-container">
      <h1 class="logsign-title">Verify your email</h1>
      <h2 class="logsign-description">
        <span *ngIf="!codeSent && submitting">Sending a verification code to <strong>{{userEmail}}</strong>…</span>
        <span *ngIf="codeSent">Enter the 4-digit code we sent to <strong>{{userEmail}}</strong></span>
      </h2>

      <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="logsign-form">
        <app-alert-box [location]="'logsign'" class="mainAlert"></app-alert-box>

        <div class="logsign-input code" *ngIf="codeSent">
          <input name="c1" type="text" class="input" [(ngModel)]="c1" (keyup)="goToNextInput(0, $event)" maxlength="1" id="c0" autocomplete="off">
          <input name="c2" type="text" class="input" [(ngModel)]="c2" (keyup)="goToNextInput(1, $event)" maxlength="1" id="c1" autocomplete="off">
          <input name="c3" type="text" class="input" [(ngModel)]="c3" (keyup)="goToNextInput(2, $event)" maxlength="1" id="c2" autocomplete="off">
          <input name="c4" type="text" class="input" [(ngModel)]="c4" (keyup)="goToNextInput(3, $event)" maxlength="1" id="c3" autocomplete="off">
        </div>

        <div class="countdown" *ngIf="codeSent && !showResend">{{resendTimer}}</div>

        <div class="logsign-extra flex-container space-between" *ngIf="codeSent">
          <div class="message code">
            Didn't receive a code?
            <button type="button" (click)="requestCode()" [disabled]="!showResend || submitting">Resend</button>
          </div>
        </div>

        <div class="logsign-input submit" *ngIf="codeSent">
          <input type="submit" class="input" value="VERIFY" [disabled]="submitting">
        </div>
      </form>
    </div>
  </div>
</div>
